export default {};

const replayCanvasIntegration = () => {
  throw new Error(
    "The @sentry-internal/replay-canvas feature has been disable",
  );
};

export { replayCanvasIntegration };
